const lodash = require("lodash");

export const permissions: PermissionFormat = {
  suites: {
    columns: [
      {
        title: "Suites",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "suiteAdd",
        name: "Add suites ",
        headerKey: "suites"
      },
      {
        key: "suiteEdit",
        name: "Edit any suite ",
        headerKey: "suites"
      },
      {
        key: "suiteEdit_OnlyMe",
        name: "Edit suites only created by them",
        headerKey: "suites"
      },
      {
        key: "suiteDelete",
        name: "Delete any suite ",
        headerKey: "suites"
      },
      {
        key: "suiteDelete_OnlyMe",
        name: "Delete suites only created by them  ",
        headerKey: "suites"
      }

      // {
      //   key: "suiteImport",
      //   name: "Import suites    ",
      //   headerKey: "suites"
      // },
      // {
      //   key: "suiteExport",
      //   name: "Export suites    ",
      //   headerKey: "suites"
      // }
    ]
  },
  testCases: {
    columns: [
      {
        title: "Test Cases",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "testCaseAdd",
        name: "Add test cases ",
        headerKey: "testCases"
      },
      {
        key: "testCaseEdit",
        name: "Edit any test case ",
        headerKey: "testCases"
      },
      {
        key: "testCaseEdit_OnlyMe",
        name: "Edit test cases only created by them",
        headerKey: "testCases"
      },
      {
        key: "testCaseDelete",
        name: "Delete any test case ",
        headerKey: "testCases"
      },
      {
        key: "testCaseDelete_OnlyMe",
        name: "Delete test cases only created by them  ",
        headerKey: "testCases"
      },
      {
        key: "manageRUSteps",
        name: "Can add, edit, delete reusable steps  ",
        headerKey: "testCases"
      },
      {
        key: "testCaseImport",
        name: "Import test cases    ",
        headerKey: "testCases"
      },
      {
        key: "testCaseExport",
        name: "Export test cases    ",
        headerKey: "testCases"
      },
      {
        key: "testCaseComment",
        name: "Can comment on test cases    ",
        headerKey: "testCases"
      },
      {
        key: "testCaseBulkUpdate",
        name: "Can bulk update test cases ",
        headerKey: "testCases"
      },
      {
        key: "manageTags",
        name: "Can add, edit, delete tags  ",
        headerKey: "testCases"
      }
      // {
      //   key: "manageRequirements",
      //   name: "Can add, edit, delete requirements  ",
      //   headerKey: "testCases"
      // }
    ]
  },
  testPlan: {
    columns: [
      {
        title: "Test Plans",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "testPlanAdd",
        name: "Create test plans  ",
        headerKey: "testPlan"
      },

      {
        key: "testPlanEdit",
        name: "Edit any test plan ",
        headerKey: "testPlan"
      },
      {
        key: "testPlanEdit_OnlyMe",
        name: "Edit test plans only created by them",
        headerKey: "testPlan"
      },
      {
        key: "testPlanDelete",
        name: "Delete any test plan",
        headerKey: "testPlan"
      },
      {
        key: "testPlanDelete_OnlyMe",
        name: "Delete test plans only created by them  ",
        headerKey: "testPlan"
      },
      {
        key: "testPlanBulkEdit",
        name: "Can bulk update test plans ",
        headerKey: "testPlan"
      },
      {
        key: "testPlanComment",
        name: "Can comment on test cases within test plans",
        headerKey: "testPlan"
      }
    ]
  },
  testPlanFolders: {
    columns: [
      {
        title: "Test Plan Folders",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "testPlanFolderAdd",
        name: "Create test plan folders  ",
        headerKey: "testPlanFolders"
      },

      {
        key: "testPlanFolderEdit",
        name: "Edit any test plan folder",
        headerKey: "testPlanFolders"
      },
      {
        key: "testPlanFolderEdit_OnlyMe",
        name: "Edit test plan folders only created by them",
        headerKey: "testPlanFolders"
      },
      {
        key: "testPlanFolderDelete",
        name: "Delete any test plan folder",
        headerKey: "testPlanFolders"
      },
      {
        key: "testPlanFolderDelete_OnlyMe",
        name: "Delete  test plan folders only created by them  ",
        headerKey: "testPlanFolders"
      }
    ]
  },
  testPlanRun: {
    columns: [{ title: "Running Test Cases ", dataIndex: "name" }],
    values: [
      {
        key: "testPlanRun_OnlyMe",
        name: "Run  test cases  only assigned to them  ",
        headerKey: "testPlanRun"
      },
      {
        key: "testPlanRun",
        name: "Run  any test case  ",
        headerKey: "testPlanRun"
      },
      {
        key: "testPlanRunChangeAssignee",
        name: "Can change assignee of Test cases in a test plan  ",
        headerKey: "testPlanRun"
      },
      {
        key: "testPlanRunBulk",
        name: "Can bulk update test runs status and assignee  ",
        headerKey: "testPlanRun"
      }
    ]
  },
  reports: {
    columns: [
      {
        title: "Reports  ",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "reportView",
        name: "Can view reports ",
        headerKey: "reports"
      },
      {
        key: "reportAdd",
        name: "Can create reports ",
        headerKey: "reports"
      },
      {
        key: "reportDelete",
        name: "Can delete reports",
        headerKey: "reports"
      }
    ]
  },
  testDatasets: {
    columns: [
      {
        title: "Test Datasets  ",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "testdatasetAdd",
        name: "Add test dataset",
        headerKey: "testDatasets"
      },
      {
        key: "testdatasetEdit",
        name: "Edit any test dataset",
        headerKey: "testDatasets"
      },
      {
        key: "testdatasetEdit_OnlyMe",
        name: "Edit test dataset only created by them",
        headerKey: "testDatasets"
      },
      {
        key: "testdatasetDelete",
        name: "Delete any test dataset",
        headerKey: "testDatasets"
      },
      {
        key: "testdatasetDelete_OnlyMe",
        name: "Delete test dataset only created by them  ",
        headerKey: "testDatasets"
      }
    ]
  },
  misc: {
    columns: [
      {
        title: "Miscellaneous ",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "manageSavedFilter",
        name: "Can add, edit and delete global saved filters ",
        headerKey: "misc"
      },

      {
        key: "deleteAttachments",
        name: "Can delete any attachments",
        headerKey: "misc"
      },
      // {
      //   key: "manageDefect",
      //   name: "Can edit defects (TestCollab only)",
      //   headerKey: "misc"
      // },
      {
        key: "manageProjectMembers",
        name: "Can add, edit and delete team members in a project ",
        headerKey: "misc"
      },
      {
        key: "testCaseReview",
        name: "Can review and approve test cases",
        headerKey: "misc"
      },
      {
        key: "validatePlanCase",
        name: "Can approve/reject test cases for a test plan",
        headerKey: "misc"
      }
    ]
  },
  requirements: {
    columns: [
      {
        title: "Requirements (TestCollab)",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "requirementAdd",
        name: "Create Requirement",
        headerKey: "requirements"
      },

      {
        key: "requirementEdit",
        name: "Edit any requirements",
        headerKey: "requirements"
      },
      {
        key: "requirementEdit_OnlyMe",
        name: "Edit requirements only created by them",
        headerKey: "requirements"
      },
      {
        key: "requirementDelete",
        name: "Delete any requirements",
        headerKey: "requirements"
      },
      {
        key: "requirementDelete_OnlyMe",
        name: "Delete requirements only created by them  ",
        headerKey: "requirements"
      }
      // {
      //   key: "requirementsBulkAction",
      //   name: "Can bulk update test plans ",
      //   headerKey: "requirements"
      // }
    ]
  },
  requirementFolders: {
    columns: [
      {
        title: "Requirement Folders (TestCollab)",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "requirementFolderAdd",
        name: "Create requirement folders  ",
        headerKey: "requirementFolders"
      },
      {
        key: "requirementFolderEdit",
        name: "Edit any requirement folder",
        headerKey: "requirementFolders"
      },
      {
        key: "requirementFolderEdit_OnlyMe",
        name: "Edit requirement folders only created by them",
        headerKey: "requirementFolders"
      },
      {
        key: "requirementFolderDelete",
        name: "Delete any requirement folder",
        headerKey: "requirementFolders"
      },
      {
        key: "requirementFolderDelete_OnlyMe",
        name: "Delete requirement folders only created by them  ",
        headerKey: "requirementFolders"
      }
    ]
  },
  issues: {
    columns: [
      {
        title: "Issues (TestCollab)",
        dataIndex: "name"
      }
    ],
    values: [
      {
        key: "issueAdd",
        name: "Add issues ",
        headerKey: "issues"
      },
      {
        key: "issueEdit",
        name: "Edit any issue ",
        headerKey: "issues"
      },
      {
        key: "issueEdit_OnlyMe",
        name: "Edit issues only created by them",
        headerKey: "issues"
      },
      {
        key: "issueDelete",
        name: "Delete any issue ",
        headerKey: "issues"
      },
      {
        key: "issueDelete_OnlyMe",
        name: "Delete issues only created by them  ",
        headerKey: "issues"
      }
    ]
  }
};

export interface PermissionFormat {
  testCases: PermissionTableFormat;
  suites: PermissionTableFormat;
  testPlanFolders: PermissionTableFormat;
  testPlan: PermissionTableFormat;
  testPlanRun: PermissionTableFormat;
  reports: PermissionTableFormat;
  misc: PermissionTableFormat;
  requirements: PermissionTableFormat;
  requirementFolders: PermissionTableFormat;
  issues: PermissionTableFormat;
  testDatasets: PermissionTableFormat;
}

export interface PermissionTableFormat {
  columns: { title: string; dataIndex: string }[];
  values: { key: string; name: string; headerKey: string }[];
}

export interface Permissions {
  testCases: string[];
  suites: string[];
  testPlan: string[];
  testPlanFolders: string[];
  testPlanRun: string[];
  reports: string[];
  misc: string[];
  requirements: string[];
  requirementFolders: string[];
  issues: string[];
  testDatasets: string[];
}

export const getCheckBoxProps = (
  selectedPermissions,
  keysToRestrict
) => record => {
  const restrictCheck = key => {
    if (
      keysToRestrict &&
      Array.isArray(keysToRestrict) &&
      keysToRestrict.includes(key)
    ) {
      return true;
    }
    switch (key) {
      case "testCaseBulkUpdate":
        if (
          selectedPermissions["testCases"] instanceof Array &&
          selectedPermissions["testCases"].includes("testCaseAdd") &&
          selectedPermissions["testCases"].includes("testCaseEdit") &&
          selectedPermissions["testCases"].includes("testCaseDelete")
        )
          return false;
        else return true;

        break;
      case "testPlanBulkEdit":
        if (
          selectedPermissions["testPlan"] instanceof Array &&
          selectedPermissions["testPlan"].includes("testPlanAdd") &&
          selectedPermissions["testPlan"].includes("testPlanEdit") &&
          selectedPermissions["testPlan"].includes("testPlanDelete")
        )
          return false;
        else return true;

        break;
      case "testPlanRunChangeAssignee":
        if (
          selectedPermissions["testPlan"] instanceof Array &&
          selectedPermissions["testPlan"].includes("testPlanAdd")
        )
          return true;
        else return false;

        break;
      case "testPlanRunBulk":
        if (
          selectedPermissions["testPlanRun"] instanceof Array &&
          selectedPermissions["testPlanRun"].includes("testPlanRun") &&
          selectedPermissions["testPlanRun"].includes(
            "testPlanRunChangeAssignee"
          )
        )
          return false;
        else return true;

        break;
      case "requirementsBulkEdit":
        if (
          selectedPermissions["requirements"] instanceof Array &&
          selectedPermissions["requirements"].includes("requirementAdd") &&
          selectedPermissions["requirements"].includes("requirementEdit") &&
          selectedPermissions["requirements"].includes("requirementDelete")
        )
          return false;
        else return true;

        break;
      default:
        return false;
        break;
    }
  };

  const getChecked = ({ key, headerKey }: any) => {
    switch (key) {
      case "testPlanRunChangeAssignee":
        if (
          selectedPermissions["testPlan"].includes("testPlanAdd") ||
          (Array.isArray(selectedPermissions[headerKey]) &&
            !restrictCheck(key) &&
            selectedPermissions[headerKey].includes(key))
        )
          return true;
        break;

      default:
        return (
          Array.isArray(selectedPermissions[headerKey]) &&
          !restrictCheck(key) &&
          selectedPermissions[headerKey].includes(key)
        );
        break;
    }
    // break;
  };

  return {
    name: record["name"],
    checked: getChecked(record),
    disabled: restrictCheck(record["key"])
  };
};

export const hasPermission = (
  loggedInUser: Object,
  permissionKey: string
): boolean | "OnlyMe" => {
  if (loggedInUser["rank"] === "Administrator") return true;
  if (!(loggedInUser && loggedInUser["permissions"] instanceof Array))
    return false;
  if (loggedInUser["permissions"].includes(permissionKey)) return true;
  if (loggedInUser["permissions"].includes(permissionKey + "_OnlyMe"))
    return "OnlyMe";
  return false;
};

export const getRestrictedKeys = planDetails => {
  let restrictedKeys = [];
  if (planDetails && planDetails.features) {
    const isInbuiltRequirementAllowed = lodash.get(
      lodash.find(lodash.get(planDetails, "features", []), {
        name: "inbuiltRequirement"
      }),
      "allowed"
    );
    if (!isInbuiltRequirementAllowed) {
      restrictedKeys.push("requirements");
      restrictedKeys.push("requirementFolders");
    }
    const isInbuiltIssueAllowed = lodash.get(
      lodash.find(lodash.get(planDetails, "features", []), { name: "inbuilt" }),
      "allowed"
    );
    if (!isInbuiltIssueAllowed) restrictedKeys.push("issues");
    const isReviewFeatureAllowed = lodash.get(
      lodash.find(lodash.get(planDetails, "features", []), {
        name: "testCaseApproval"
      }),
      "allowed"
    );
    if (!isReviewFeatureAllowed) restrictedKeys.push("testCaseReview");

    const isPlanCaseValidationFeatureAllowed = lodash.get(
      lodash.find(lodash.get(planDetails, "features", []), {
        name: "planCaseValidator"
      }),
      "allowed"
    );
    if (!isPlanCaseValidationFeatureAllowed)
      restrictedKeys.push("validatePlanCase");
  }
  return restrictedKeys;
};
